import getCroppedImg from '@helpers/cropImage';
import { action, makeObservable, observable } from 'mobx';

export const MAX_ZOOM = 3;
export const MIN_ZOOM = 1;
export const ZOOM_STEP = 0.1;
export const ROTATION_STEP = 5;
export const MAX_ROTATION = 360;
export const MIN_ROTATION = 0;

class ProfilePictureStore {
  image: string = null;

  imageName: string = '';

  crop = { x: 0, y: 0 };

  rotation: number = 0;

  zoom: number = 1;

  croppedAreaPixels = null;

  constructor() {
    makeObservable(this, {
      image: observable,
      imageName: observable,
      crop: observable,
      rotation: observable,
      zoom: observable,
      croppedAreaPixels: observable,
      setImage: action.bound,
      setImageName: action.bound,
      setCrop: action.bound,
      setRotation: action.bound,
      setZoom: action.bound,
      setCroppedAreaPixels: action.bound,
      onCropComplete: action.bound,
      handleZoomIn: action.bound,
      handleZoomOut: action.bound,
      handleRotateCw: action.bound,
      handleRotateAntiCw: action.bound,
      getProcessedImage: action.bound,
      resetStore: action.bound,
    });
  }

  setImage(data: string) {
    this.image = data;
  }

  setImageName(name: string) {
    this.imageName = name;
  }

  setCrop(data) {
    this.crop = data;
  }

  setRotation(data) {
    this.rotation = data;
  }

  setZoom(data) {
    this.zoom = data;
  }

  setCroppedAreaPixels(data) {
    this.croppedAreaPixels = data;
  }

  onCropComplete(_croppedArea, data) {
    this.croppedAreaPixels = data;
  }

  handleZoomIn() {
    if (this.zoom < MAX_ZOOM) {
      this.zoom += ZOOM_STEP * 2;
    }
  }

  handleZoomOut() {
    if (this.zoom > MIN_ZOOM) {
      this.zoom -= ZOOM_STEP * 2;
    }
  }

  handleRotateCw() {
    this.rotation += ROTATION_STEP;
  }

  handleRotateAntiCw() {
    this.rotation -= ROTATION_STEP;
  }

  async getProcessedImage(): Promise<File | undefined> {
    if (this.image && this.croppedAreaPixels) {
      const croppedImage: any = await getCroppedImg(this.image, this.croppedAreaPixels, this.rotation);
      const imageFile = new File([croppedImage.file], this.imageName, {
        type: 'image/png',
      });
      return imageFile;
    }
    return undefined;
  }

  resetStore() {
    this.image = null;
    this.crop = { x: 0, y: 0 };
    this.rotation = 0;
    this.zoom = 1;
    this.croppedAreaPixels = null;
  }
}

export const profilePictureStore = new ProfilePictureStore();
